import React, { useEffect } from "react";

import {
  ModalContent,
  ModalHeader,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableRow,
} from "semantic-ui-react";


type ModRehabOrderLogProps = {
  onEvent: (e: any) => any;

  rehabOrderActionLogList?: any[];
  orderId?: number;
};

const ModRehabOrderLog = (props: ModRehabOrderLogProps) => {
  useEffect(() => {
    if (props.orderId) {
      props.onEvent({
        message: "getRhbActionLog",
        params: { id: props.orderId },
      });
    }
  }, [props.orderId]);

  return (
    <>
      <ModalHeader>Document Log</ModalHeader>
      <ModalContent>
        <Table minRows="10" showPagination={false}>
          <TableHeader className="rehab-treatment">
            <TableRow>
              <TableHeaderCell width={2}>User</TableHeaderCell>
              <TableHeaderCell width={2}>Action</TableHeaderCell>
              <TableHeaderCell width={2}>Date-time</TableHeaderCell>
              <TableHeaderCell width={2}>Note</TableHeaderCell>
            </TableRow>
          </TableHeader>
          <TableBody>
            {props.rehabOrderActionLogList?.map((row, index) => (
              <TableRow key={`action-log${index}`}>
                <TableCell>{row.user_fullname}</TableCell>
                <TableCell>{row.action}</TableCell>
                <TableCell>{row.datetime_th}</TableCell>
                <TableCell>{row.note}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </ModalContent>
    </>
  );
};

ModRehabOrderLog.displayName = "ModRehabOrderLog";

export default React.memo(ModRehabOrderLog);
